import React, { useEffect, useMemo, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../_redux/reconcile/reconcileAction';
import * as uiHelpers from '../ReconcileUIHelpers';
import { DateColumnFormatter } from './column-formatters/DateColumnsFormatter'
import { StatusColumnFormatter } from './column-formatters';
import { currencyFormatter } from '../../../../../../_metronic/_helpers';

import {
    getHandlerTableChange,
    NoRecordsFoundMessage,
    PleaseWaitMessage, toastOption,
} from '../../../../../../_metronic/_helpers';
import * as columnFormatters from './column-formatters';
import { Pagination } from '../../../../../../_metronic/_partials/controls';
import { useReconcileUIContext } from '../ReconcileUIContext';
import { toast } from "react-toastify";
// import { act } from 'react-dom/test-utils';
import { ReconcileDeleteDialog } from './reconcile-delete-dialog/ReconcileDeleteDialog';
import { BlockOrg, RoleChecker } from '../../../../../RoleChecker';

export const ReconcileTable = (props) => {
    // Reconcile UI Context
    const reconcileUIContext = useReconcileUIContext();
    const reconcileUIProps = useMemo(() => {
        return {
            queryParams: reconcileUIContext.queryParams,
            setQueryParams: reconcileUIContext.setQueryParams,
            newReconcileClick: reconcileUIContext.newReconcileClick,
            openEditReconcilePage: reconcileUIContext.openEditReconcilePage,
            openChooseReconcilePage: reconcileUIContext.openChooseReconcilePage,
        };
    }, [reconcileUIContext]);

    // Getting curret state of branch list from store (Redux)
    const { currentState } = useSelector(
        (state) => ({ currentState: state.reconcile }),
        shallowEqual,
    );

    const { listLoading, entities, totalCount, error } = currentState
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [selectedRow, setselectedRow] = useState('')

    const handleClickOpenDeleteDialog = (uuid) => {
        setselectedRow(uuid)
        setOpenDeleteDialog(true);
    };

    const handleCloseDeleteDialog = () => {
        setOpenDeleteDialog(false);
    };

    if (error) {
        toast.error(error, toastOption)
    }
    const dispatch = useDispatch();
    useEffect(() => {
        //Requset ke Donatur Action
        dispatch(actions.fetchReconciles(reconcileUIProps.queryParams));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, reconcileUIProps.queryParams]);

    const deleteReconcile = (value) => {
        dispatch(actions.deleteReconcile(value.uuid)).then((response) => {
            toast.success(response, toastOption);
            dispatch(actions.fetchReconcile(reconcileUIProps.queryParams));
        })
    }
    const manualReconcile = (value) => {
        dispatch(actions.manualReconcile(value.uuid)).then((response) => {
            toast.success(response, toastOption);
            dispatch(actions.fetchReconcile(reconcileUIProps.queryParams));
        })
    }

    const allowEdit = RoleChecker("Edit", "rekonsiliasi_donasi")
    const allowDelete = RoleChecker("Delete", "rekonsiliasi_donasi")

    // console.log(entities);

    // Table columns
    const columns = [
        {
            dataField: 'user.name',
            text: 'Dibuat Oleh',
        },
        {
            dataField: 'reconcile_hid',
            text: 'Settlement HID',
        },
        {
            dataField: 'status',
            text: "Status",
            formatter: StatusColumnFormatter
        },
        {
            dataField: 'trx_date',
            text: 'Tanggal Transaksi',
            formatter: DateColumnFormatter
        },
        // {
        //     dataField: 'bank_pooling',
        //     text: 'Cabang',
        //     formatter: (cell, row) => {
        //         return `${cell.branch.name}`
        //     }
        // },
        // {
        //     dataField: 'bank_pooling',
        //     text: 'Bank',
        //     formatter: (cell, row) => {
        //         return `${cell.bank.name}`
        //     }
        // },
        // {
        //     dataField: 'bank_pooling',
        //     text: 'Nomor Bank Pengumpul',
        //     formatter: (cell, row) => {
        //         return `${cell.account_number}`
        //     }
        // },
        {
            dataField: 'amount',
            text: 'Nominal',
            headerClasses: 'text-right',
            classes: 'text-right',
            formatter: (cell, row) => {
                return currencyFormatter(cell)
            }
        },
        {
            dataField: 'diff_amount',
            text: 'Selisih Nominal',
            headerClasses: 'text-right',
            classes: 'text-right',
            formatter: (cell, row) => {
                return currencyFormatter(cell)
            }
        },
        {
            dataField: 'action',
            text: 'Actions',
            formatter: columnFormatters.ActionsColumnFormatter,
            formatExtraData: {
                openEditReconcilePage: reconcileUIProps.openEditReconcilePage,
                openChooseReconcilePage: reconcileUIProps.openChooseReconcilePage,
                deleteReconcile: handleClickOpenDeleteDialog,
                manualReconcile: manualReconcile,
                allowEdit,
                allowDelete,
                blockOrg: BlockOrg()
            },
            classes: 'text-right pr-0',
            headerClasses: 'text-right pr-3',
            style: {
                minWidth: '100px',
            },
        },
    ];


    // Table pagination properties
    const paginationOptions = {
        custom: true,
        totalSize: totalCount,
        sizePerPageList: uiHelpers.sizePerPageList,
        sizePerPage: reconcileUIProps.queryParams.pageSize,
        page: reconcileUIProps.queryParams.pageNumber,
    };

    return (
        <>
            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                {({ paginationProps, paginationTableProps }) => {
                    return (
                        <Pagination
                            isLoading={listLoading}
                            paginationProps={paginationProps}
                        >
                            <BootstrapTable
                                wrapperClasses="table-responsive"
                                classes="table table-head-custom table-vertical-center overflow-hidden"
                                bootstrap4
                                bordered={false}
                                remote
                                keyField="uuid"
                                data={entities === null ? [] : entities}
                                columns={columns}
                                // defaultSorted={uiHelpers.defaultSorted}
                                onTableChange={getHandlerTableChange(
                                    reconcileUIProps.setQueryParams,
                                )}
                                {...paginationTableProps}
                            >
                                <PleaseWaitMessage entities={entities} />
                                <NoRecordsFoundMessage entities={entities} />
                            </BootstrapTable>
                        </Pagination>
                    );
                }}
            </PaginationProvider>
            <ReconcileDeleteDialog
                handleCloseDeleteDialog={handleCloseDeleteDialog}
                openDeleteDialog={openDeleteDialog}
                selectedRow={selectedRow}
                params={reconcileUIProps.queryParams}
            />
        </>
    )

}